import { render } from "./ViTrainInfo.vue?vue&type=template&id=74af707d&scoped=true"
import script from "./ViTrainInfo.vue?vue&type=script&lang=js"
export * from "./ViTrainInfo.vue?vue&type=script&lang=js"

import "./ViTrainInfo.vue?vue&type=style&index=0&id=74af707d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-74af707d"

export default script